import { formatCurrency, formatPercentage } from "@/utils/formatters";

import styles from "./DiscountLine.module.css";

interface DiscountLineProps {
  discount: { amount?: number; percentage?: number; description?: string };
  currencyCode: string;
}

export const DiscountLine = ({ discount, currencyCode }: DiscountLineProps) => {
  return (
    <p className="small amount">
      <span className={styles.discountText}>
        {discount.amount && discount.amount > 0 && (
          <>{formatCurrency(discount.amount, currencyCode, false, true)}</>
        )}
        {discount.percentage && discount.percentage > 0 && (
          <>
            {discount.amount && " "}({formatPercentage(discount.percentage)})
          </>
        )}
      </span>
    </p>
  );
};
